import { request, unwrap } from '../client';
import type { ApiResponse, GrantOperatorRequest, OperatorDto } from '../types';

const BASE = '/api/saas-admin/operators';

export const operatorsApi = {
  async list(): Promise<OperatorDto[]> {
    const res = await request<ApiResponse<OperatorDto[]>>('GET', BASE);
    return unwrap(res);
  },

  async grant(req: GrantOperatorRequest): Promise<OperatorDto> {
    const res = await request<ApiResponse<OperatorDto>>('POST', BASE, { json: req });
    return unwrap(res);
  },

  async revoke(userId: number): Promise<void> {
    await request<void>('DELETE', `${BASE}/${userId}`);
  },
};
